import StatsGl from "stats-gl"

import Experience from "../"

export default class Stats {
  stats: StatsGl | undefined
  debug: Experience["debug"]
  experience: Experience

  constructor() {
    this.experience = Experience.getInstance()
    this.debug = this.experience.debug

    if (!this.debug.ui) {
      return
    }

    this.stats = new StatsGl({
      trackGPU: true,
      horizontal: false,
    })

    document.body.appendChild(this.stats.dom)

    this.stats.init(this.experience.renderer.instance)
  }

  update() {
    if (!this.stats) {
      return
    }

    this.stats.update()
  }
}
